<script lang="ts">
  import { Header, Page, Ver, WithResource } from "$components";
  import api, { fromApi } from "$parkito-api";

  type Props = { params: { invite_code?: string } };
  const { params }: Props = $props();
  const acceptInviteCall = fromApi((inviteCode: string) =>
    api.acceptUserInvite({ body: { invitedUserId: inviteCode } })
  );

  if (params.invite_code) {
    $acceptInviteCall.load(params.invite_code);
  }
</script>

<Page backButton={false} title="Acceptera inbjudan">
  {#snippet content()}
    {#if params.invite_code === undefined}
      <h1>Kod saknas</h1>
    {:else}
      <WithResource
        api={acceptInviteCall}
        loadingText="Accepterar inbjudan..."
        error="Något gick fel medan vi ordnade din inbjudan. Var god kontakta kundservice."
      >
        {#snippet child()}
          <Ver margin="m" gap="m">
            <Header size="2">Välkommen till parkando</Header>
            <p>
              Din inbjudan är klappad och klar. Du kan nu gå vidare till <a
                href="#/"
                class="underline"
              >
                mina sidor</a>
            </p>
            <p>
              Du kan behöva ladda om sidan för att få alla behörigheter som du
              behöver.
            </p>
          </Ver>
        {/snippet}
      </WithResource>
    {/if}
  {/snippet}
</Page>
